<template>
    <section
        v-if="!showThirdNext"
        class="pop-form pop-sign-log register"
        :class="options.registerClass || ''"
        :style="{ backgroundColor: bgColor }"
    >
        <div v-if="step === 1" class="step1">
            <hgroup>
                <h2 v-if="registerTitle" v-html="registerTitle"></h2>
                <h3 v-if="registerSubTitle" v-html="registerSubTitle"></h3>
            </hgroup>
            <v-form
                :onSubmit="emailSubmit"
                :onSuccess="emailSubmitSuccess"
                :onError="emailSumbitError"
                ref="form-step1"
                key="step1"
            >
                <!--  Mail  start -->
                <v-input
                    name="email"
                    type="email"
                    :placeholder="$t('common:emailAddress')"
                    required
                    focus
                    clearable
                    :validateConfig="{
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': hasUserCallBack
                    }"
                    @input="onTrackEmail(regType.email)"
                >
                    <p class="label">{{ $t('emailAddress') }}*</p>
                </v-input>
                <!--  Mail  end -->
                <!-- continue button start -->
                <div :class="{'submit':true, disabled: submitDisabled}">
                    <input
                        type="submit"
                        :value="options.submitRegister || $t('continue')"
                        :style="options.submitRegisterStyle || {}"
                    />
                </div>
                <!-- continue button end -->

                <!-- checkbox agreement start  -->
                <div
                    v-if="options.hasVow && options.agreement"
                    class="agree-lender agree-box"
                >
                    <label class="clearfix">
                        <input
                            type="checkbox"
                            checked
                            name="agree"
                            value="true"
                        />
                        <span class="checkbox-new-style"></span>
                        <span
                            class="agree-txt"
                            v-html="options.agreement"
                        ></span>
                    </label>
                </div>
                <!-- checkbox agreement end -->

                <!-- error start -->
                <p
                    v-show="registerErrorShow || thirdPartErrorShow"
                    class="mg-error"
                >
                    {{ registerErrorMsg || thirdPartErrorMsg }}
                </p>
                <!-- error end -->
            </v-form>
            <template v-if="showFacebook || showGoogle">
                <p class="desc">{{ $t('or') }}</p>
                <ThirdBox
                    theme="standard"
                    :enableFb="showFacebook"
                    :enableGoogle="showGoogle"
                    :fbBtnText="$t('common:fbBtnText')"
                    :googleBtnText="$t('common:googleBtnText')"
                    @auth="authCallback"
                >
                </ThirdBox>
            </template>
            <p class="sign-in">
                {{ $t('register.oldHere') }}?
                <a
                    class="mg-color"
                    @click.prevent="changeType('login')"
                    rel="noopener noreferrer"
                >{{ $t('register.signIn') }}</a
                >
            </p>
        </div>
        <div v-if="step === 2" class="step2">
            <hgroup>
                <h2 v-if="registerTitleTwo" v-html="registerTitleTwo"></h2>
                <h3
                    v-if="registerSubTitleTwo"
                    v-html="registerSubTitleTwo"
                ></h3>
            </hgroup>
            <v-form
                :onSubmit="registerSubmit"
                :onSuccess="registerSubmitSuccess"
                :onError="registerSumbitError"
                ref="form-step2"
                key="step2"
            >
                <template v-if="options.nameType === 2">
                    <v-input
                        name="firstName"
                        type="text"
                        :placeholder="$t('firstName')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        focus
                        clearable
                        @input="onTrackName(regType.name)"
                    >
                        <p>
                            {{ $t('firstName') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                    <v-input
                        name="lastName"
                        type="text"
                        :placeholder="$t('lastName')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    >
                        <p class="next-p">
                            {{ $t('lastName') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                </template>
                <template v-else-if="options.nameType === 3">
                    <v-input
                        class="half"
                        name="prefix"
                        type="text"
                        :placeholder="$t('prefix')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                        focus
                    >
                        <p>
                            {{ $t('prefix') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                    <v-input
                        class="half"
                        name="firstName"
                        type="text"
                        :placeholder="$t('firstName')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                        @input="onTrackName(regType.name)"
                    >
                        <p>
                            {{ $t('firstName') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                    <v-input
                        class="half"
                        name="lastName"
                        type="text"
                        :placeholder="$t('lastName')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    >
                        <p class="next-p">
                            {{ $t('lastName') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                    <v-input
                        class="half"
                        name="suffix"
                        type="text"
                        :placeholder="$t('suffix')"
                        :required="options.nameRequired || false"
                        :maxlength="30"
                        clearable
                    >
                        <p class="next-p">
                            {{ $t('suffix') }}
                            <span
                                v-if="options.nameRequired"
                                class="mg-required"
                            >*</span
                            >
                        </p>
                    </v-input>
                </template>
                <v-input
                    v-else
                    name="fullname"
                    type="text"
                    :placeholder="$t('fullName')"
                    :required="options.nameRequired || false"
                    :maxlength="30"
                    focus
                    clearable
                    @input="onTrackName(regType.name)"
                >
                    <p>
                        {{ $t('fullName') }}
                        <span v-if="options.nameRequired" class="mg-required"
                        >*</span
                        >
                    </p>
                </v-input>
                <v-input
                    v-if="options.note"
                    name="note"
                    type="text"
                    :placeholder="options.note.text"
                    :required="options.note.required || false"
                    :maxlength="options.note.length || 50"
                    clearable
                >
                    <p class="next-p">
                        {{ options.note.text }}
                        <span v-if="options.note.required" class="mg-required"
                        >*</span
                        >
                    </p>
                </v-input>
                <!-- phone start -->
                <v-input
                    name="phone"
                    type="tel"
                    :placeholder="
                        $t('phone') +
                            (phoneRequired ? '*' : '') +
                            ' (' +
                            $t('register.usedAsPwd') +
                            ')'
                    "
                    :required="phoneRequired"
                    :validateConfig="{
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    }"
                    clearable
                    @input="onTrackPhone(regType.phone)"
                >
                    <p class="next-p">
                        {{ $t('phone') }}
                        <span class="mg-required" v-if="phoneRequired">*</span>
                    </p>
                </v-input>
                <div v-if="!!phoneDesciption" v-html="phoneDesciption"></div>
                <!-- phone end -->
                <disclaimer :disclaimerUniqId="disclaimerUniqId" @updateChecked="updateChecked" class="pop-register-disclaimer" color="#505050" :bgColor="bgColor" :btnText="options.submitRegisterTwo || $t('submit')" />
                <!-- submit start -->
                <div :class="{'submit':true, disabled:disclaimerSubmitDisabled}" :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''">
                    <input
                        type="submit"
                        :value="options.submitRegisterTwo || $t('submit')"
                        :style="options.submitRegisterStyleTwo || {}"
                    />
                </div>
                <p
                    v-show="registerErrorShow || thirdPartErrorShow"
                    class="mg-error"
                >
                    {{ registerErrorMsg || thirdPartErrorMsg }}
                </p>
                <!-- submit end -->
            </v-form>
        </div>
    </section>
    <third-register-next
        ref="third-next"
        v-else
        :fullname="
            authData.fullname ||
                (authData.firstName
                    ? authData.firstName + ' ' + authData.lastName || ''
                    : authData.lastName || '')
        "
        :email="authData.email"
        :phoneRequired="phoneRequired"
        :thirdPartErrorShow="thirdPartErrorShow"
        :thirdPartErrorMsg="thirdPartErrorMsg"
        :thirdRegisterSubmit="thirdRegisterSubmit"
        :thirdRegisterSubmitSuccess="thirdRegisterSubmitSuccess"
        :thirdRegisterSumbitError="thirdRegisterSumbitError"
        :options="options"
    ></third-register-next>
</template>

<script>
import register from '../register.js';
import thirdPart from '../third-part.js';
import thirdRegisterNextVue from './third-register-next.vue';
import { singleColumn } from '../set-gtm-data-mixins';

export default {
    mixins: [register, thirdPart, singleColumn],
    components: {
        'third-register-next': thirdRegisterNextVue
    }
};
</script>
